// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1kQ3S","savePackageButton":"ClientWallet_savePackageButton__3GRUR"};